export default __webpack_public_path__ + "static/media/Teacher.6e6865f8.svg";